import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-project-picker-container', {
    height: '300px',
});

cssRule('.tb-project-picker', {
    position: 'relative',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    height: '100%',
});

